import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoadingComponent} from './loading.component';
import {LoadingErrorComponent} from './loading-error/loading-error.component';
import { LoadingEmptyComponent } from './loading-empty/loading-empty.component';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule
  ],
  declarations: [LoadingComponent, LoadingErrorComponent, LoadingEmptyComponent],
  exports: [LoadingComponent, LoadingErrorComponent, LoadingEmptyComponent]
})
export class LoadingModule {
}
